import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function InterestFactors({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/HomeEducation");
    };

    const goPrev = () => {
        navigate("/InterestDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Factors that Affect Interest
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Interest rates are mainly affected by supply and demand, but other factors can 
                </div>
                <div className="text-[#000000] text-3xl">
                    affect them as well.  Inflation is directly proportional to interest rates.  Through 
                </div>
                <div className="text-[#000000] text-3xl">
                    changes in monetary policy, the government can affect interest rates, and the 
                </div>
                <div className="text-[#000000] text-3xl">
                    federal funds rate, which is an interest rate set by the government, can also affect 
                </div>
                <div className="text-[#000000] text-3xl">
                    interest rates.
                </div>
                <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                    onClick={goNext}
                >
                    Next
                </button>
                <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                    onClick={goPrev}
                >
                    Prev
                </button>
            </div>
        </div>
    );
}